import React, { useRef } from "react";

const OtpField = ({ name, otpValues, setOtpValues, disable }) => {
  const otpFieldsRef = useRef([]);

  const handleInput = (index, value) => {
    if (value.length > 1) {
      return;
    }
    const newOtpValues = [...otpValues];
    newOtpValues[index] = value;

    const regex = /^[0-9]*[.,]?[0-9]*$/;

    if (!regex.test(newOtpValues[index].toString())) {
      return;
    } else {
      setOtpValues(newOtpValues);
    }
    if (value.length === 1 && index < otpValues.length - 1 && value !== "") {
      otpFieldsRef.current[index + 1].focus();
    }
  };

  const handlePaste = (e) => {
    const paste = e.clipboardData.getData('text').replace(/\D/g, '');
    if (!paste) return;

    const pasteArray = paste.split('').slice(0, 6);
    const newOtp = [...otpValues];
    pasteArray.forEach((char, idx) => {
      newOtp[idx] = char;
    });
    setOtpValues(newOtp);
    // onChangeOTP(newOtp.join(''));

    // Focus last filled input
    const lastIndex = pasteArray.length - 1;
    if (otpFieldsRef.current[lastIndex]) {
      otpFieldsRef.current[lastIndex].focus();
    }

    e.preventDefault();
  };

  const handleBackspace = (index) => {
    if (otpValues[index] !== "") {
      const newOtpValues = [...otpValues];
      newOtpValues[index] = "";
      setOtpValues(newOtpValues);
    } else if (index > 0) {
      otpFieldsRef.current[index - 1].focus();
    }
  };

  return (
    <div className="otp-container d-flex justify-content-center" onPaste={handlePaste}>
      {otpValues.map((value, index) => (
        <input
          key={index}
          type="text"
          maxLength={1}
          className="otp-input"
          inputMode="numeric"
          disabled={disable}
          name={name}
          value={value}
          autoFocus={index === 0}
          onChange={(e) => {
            handleInput(index, e.target.value);
          }}
          onKeyDown={(e) => {
            if (e.key === "Backspace") {
              handleBackspace(index);
            }
          }}
          ref={(ref) => {
            otpFieldsRef.current[index] = ref;
          }}
        />
      ))}
    </div>
  );
};

export default OtpField;
